module.exports = __webpack_public_path__ + "img/graphql.9c29cb17.svg";